import createNamespaceContext from './helper/createNamespaceContext';
export const LINKING_PLATFORM_CONTEXT = 'linkingPlatformCtx';
export const LinkingPlatformAnalyticsContext = createNamespaceContext(LINKING_PLATFORM_CONTEXT, 'LinkingPlatformAnalyticsContext');